import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Fill in the required fields including <strong>organization name</strong>, <strong>contact email</strong>, <strong>sector</strong>, <strong>language</strong>, and <strong>home country</strong>. All required fields must be completed before saving." id="fill_in_the_required_fields_including_or.f9664e5a" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Partner Details" id="partner_details.a729f457" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>Licenses</strong> section to assign product licenses to the partner. Click <strong>Add License</strong> to browse available licenses and add them. When creating a new partner, at least one license is required." id="use_the_licenses_section_to_assign_produ.8c3c2604" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Managing Licenses" id="managing_licenses.0d0394f0" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>Users</strong> section to add administrator accounts for this partner. Click <strong>Add User</strong> to create a new user or assign an existing one. When creating a new partner, at least one user is required." id="use_the_users_section_to_add_administrat.4be6ff28" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Managing Users" id="managing_users.21ab4402" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Each section can be <strong>collapsed or expanded</strong> by clicking the section heading. In <strong>edit mode</strong>, changes to partner details are saved individually using the <strong>Save</strong> button, while licenses and users are updated immediately." id="each_section_can_be_collapsed_or_expande.e8648154" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Saving Changes" id="saving_changes.8e3f3c76" />
        }
    ],
    title: <FormattedMessage defaultMessage="Partner Create / Edit" id="partner_create_edit.e76bfc32" />
};
